import { layout } from 'thewest/App.routing'

export const entertaimentAndLifestyleSegment = layout.nestedComposition({
    type: 'janus',
    props: {
        stretchColumns: true,
        verticalSpacing: 'xl',
    },
    contentAreas: {
        left: [
            layout.component({
                type: 'lima',
                props: {
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'lifestyle',
                        offset: 0,
                        pageSize: 4,
                    },
                    sectionHeader: {
                        heading: 'Lifestyle',
                        headingUrl: '/lifestyle',
                        section: 'lifestyle',
                    },
                    verticalSpacing: 'md',
                    fixedRatios: ['16:9'],
                    finalColumns: 2,
                    stretchSelf: true,
                    cardLayout: [
                        ['teaserWithBackground'],
                        [
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                        ],
                    ],
                    cardOrientation: {
                        type: 'Landscape-Portrait',
                    },
                },
            }),
        ],
        right: [
            layout.component({
                type: 'lima',
                props: {
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'entertainment',
                        offset: 0,
                        pageSize: 4,
                    },
                    sectionHeader: {
                        heading: 'Entertainment',
                        headingUrl: '/entertainment',
                        section: 'entertainment',
                    },
                    verticalSpacing: 'md',
                    fixedRatios: ['16:9'],
                    finalColumns: 2,
                    stretchSelf: true,
                    cardLayout: [
                        ['teaserWithBackground'],
                        [
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                        ],
                    ],
                    cardOrientation: {
                        type: 'Landscape-Portrait',
                    },
                },
            }),
        ],
    },
})
